var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGooglePlay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.2718 9.44664L14.7629 7.42017L9.95557 11.0121L14.7629 14.6041L18.2837 12.5707C18.8326 12.2372 19.1602 11.6544 19.1602 11.0122C19.1602 10.3701 18.8326 9.78732 18.2718 9.44664Z",
    fill: "#FF9100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1709 11.0122C11.1656 11.0189 6.92038 16.4771 6.91694 16.4815L1.38678 20.8368C1.04642 20.4964 0.839844 20.0347 0.839844 19.5241V2.47008C0.839844 1.95965 1.04642 1.49775 1.38678 1.15747L6.91694 5.54278C6.92038 5.5472 11.1656 11.0054 11.1709 11.0122Z",
    fill: "#25D9F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.171 11.0123L9.95557 12.5801V9.44434L11.171 11.0123Z",
    fill: "#00C0F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7685 7.4145L11.1708 11.0122L1.38672 1.15752C1.50822 1.0481 1.6298 0.963016 1.7635 0.877937C2.34686 0.549814 3.03969 0.561928 3.61097 0.91444L9.95542 4.64338L14.7685 7.4145Z",
    fill: "#7FE881"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7687 7.41443L11.171 11.0121L9.95557 9.7967V4.64331L14.7687 7.41443Z",
    fill: "#5BC980"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7685 14.6098L9.95542 17.381L3.59882 21.0921C3.30712 21.2622 2.99111 21.3594 2.66291 21.3594C2.35905 21.3594 2.0552 21.2743 1.7635 21.1163C1.6298 21.0313 1.50822 20.9462 1.38672 20.8368L11.1708 11.0122L14.7685 14.6098Z",
    fill: "#FF637B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7687 14.6098L9.95557 17.381V12.2276L11.171 11.0122L14.7687 14.6098Z",
    fill: "#E63950"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.c7721f81489bbb5eca1d451d4feae89b.svg";
export { ForwardRef as ReactComponent };